export default {
    methods: {
        roundNum(value, decimals = 2) {
            var sign = value >= 0 ? 1 : -1

            return (
                Math.round(value * Math.pow(10, decimals) + sign * 0.001) /
                Math.pow(10, decimals)
            ).toFixed(decimals)
        },
    },
}
